import { tabletQuery } from '@globals/themes/themeConstants'
import useMediaQuery from '@mui/material/useMediaQuery'
import { isMobileHiddenPath } from '@nav/utils'
import NoMobileAccessPage from '@shared/routing/NoMobileAccessPage'
import { Outlet, useLocation } from 'react-router'

const MobileRouteGuard = () => {
  const isTablet = useMediaQuery(tabletQuery)
  const { pathname } = useLocation()

  if (isTablet && isMobileHiddenPath(pathname)) {
    return <NoMobileAccessPage />
  }

  return <Outlet />
}

export default MobileRouteGuard
